import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, vModelText as _vModelText, withKeys as _withKeys, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createVNode as _createVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

import { ref, nextTick, watch, toRefs } from "vue";

export default /*@__PURE__*/_defineComponent({
  __name: 'inputTag',
  props: {
  isInvalid: {
    type: Boolean,
    default: false,
  },
  modelValue: {
    type: Array,
    default: () => []
  }
},
  emits: ['update:modelValue'],
  setup(__props, { emit: __emit }) {

const emit = __emit;

const props = __props;

const { modelValue } = toRefs(props);
const inputValue = ref(""); // 输入框的绑定值
const tags = ref<string[]>([]); // 存储标签的数组
const inputRef = ref<HTMLInputElement | null>(null); // 输入框的引用 

watch(modelValue, (newValue) => {
  tags.value = [...(newValue as string[])];
}, { immediate: true, deep: true });

// 添加标签
const handleAddTag = () => {
    const trimmedValue = inputValue.value.trim();
    if (trimmedValue !== "" && !tags.value.includes(trimmedValue)) {
        tags.value.push(trimmedValue);
        emit('update:modelValue', tags.value);
        inputValue.value = ""; // 清空输入框
        focusInput(); // 重新聚焦到输入框
    }
};

// 删除标签
const handleCloseTag = (index: number) => {
    tags.value.splice(index, 1);
    emit('update:modelValue', tags.value);
};

// 删除所有标签
const handleAllCloseTag = () => {
    tags.value = [];
    emit('update:modelValue', tags.value);
};

// 聚焦到输入框
const focusInput = () => {
    nextTick(() => {
        if (inputRef.value) {
          inputRef.value.focus();
        }
    });
};
  

  
return (_ctx: any,_cache: any) => {
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_CircleClose = _resolveComponent("CircleClose")!
  const _component_el_icon = _resolveComponent("el-icon")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["flex border items-start pl-[5px] pr-[5px] w-[100%] flex-wrap min-h-[40px] py-[8px] mobile-tag-container", { 'border-red-500': __props.isInvalid }]),
    onClick: focusInput
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tags.value, (tag, index) => {
      return (_openBlock(), _createBlock(_component_el_tag, {
        key: index,
        closable: "",
        onClose: ($event: any) => (handleCloseTag(index)),
        class: "mr-[5px] mb-[5px] mobile-tag",
        size: "small"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(tag), 1)
        ]),
        _: 2
      }, 1032, ["onClose"]))
    }), 128)),
    _withDirectives(_createElementVNode("input", {
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((inputValue).value = $event)),
      ref_key: "inputRef",
      ref: inputRef,
      placeholder: "多个关键字请用回车隔开",
      onKeyup: _withKeys(handleAddTag, ["enter"]),
      onBlur: handleAddTag,
      class: "inline-input mobile-input-field",
      noStyle: ""
    }, null, 544), [
      [_vModelText, inputValue.value]
    ]),
    (tags.value.length > 0)
      ? (_openBlock(), _createBlock(_component_el_icon, {
          key: 0,
          class: "cursor-pointer mobile-close-icon"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_CircleClose, { onClick: handleAllCloseTag })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ], 2))
}
}

})